import {
  Component,
  ViewChild,
  ViewContainerRef,
  ComponentFactoryResolver,
  ComponentRef,
  OnInit,
  OnDestroy,
} from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { DrawerAction, DrawerService } from "src/app/services/drawer.service";
import dataURItoBlob from '../../utils/dataURItoBlob';

@Component({
  selector: "app-drawer-container",
  templateUrl: "./drawer.component.html",
  styleUrls: ["./drawer.component.css"],
})
export class DrawerContainerComponent implements OnInit, OnDestroy {
  @ViewChild("drawerContent", { read: ViewContainerRef })
  container!: ViewContainerRef;

  private destroy$ = new Subject<void>();
  componentRef?: ComponentRef<any>;

  opened = false;
  width = "400px";
  classDrawer= 'w-1/2'
  title = "";
  actions: any[] = [];
  classes = "";

  constructor(
    private drawerService: DrawerService,
    private resolver: ComponentFactoryResolver,
  ) {}

  ngOnInit() {
    this.drawerService.drawer$
      .pipe(takeUntil(this.destroy$))
      .subscribe((config) => {
        if (!config) {
          this.close();
          return;
        }

        this.container.clear();

        const factory = this.resolver.resolveComponentFactory(config.component);

        this.componentRef = this.container.createComponent(factory);

        const instance = this.componentRef.instance;

        if (config.data) {
          instance.data = config.data;
        }
        instance.drawerRef = config.drawerRef;

        this.title = config.title || "";
        this.actions = config.actions || [];
        this.width = config.width || "450px";
        this.classDrawer = config.classDrawer || "w-1/2";
        this.classes = config.classes || "";
        this.opened = true;

        config.drawerRef.afterClosed$.subscribe(() => {
          this.close();
        });
      });
  }
  runAction(action: DrawerAction<any>) {
    if (!this.componentRef) return;

    const instance = this.componentRef.instance;

    action.action(instance);
  }
  runValidation(action: DrawerAction<any>) {
    if (!this.componentRef) return false;
    const instance = this.componentRef.instance;
    return action.validation ? action.validation(instance) : false;
  }

  close() {
    this.container.clear();
    this.opened = false;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
